<template>
  <div>
    <b-navbar sticky="true" type="light" variant="light">
		<div class="container">
			<b-navbar-brand to="/panic-befall">恐慌降临</b-navbar-brand>
			<b-navbar-nav class="ml-auto" small="true" >
				<!-- <b-nav-item to="#">概览</b-nav-item>
      			<b-nav-item to="#">如何使用</b-nav-item> -->
				<b-button rel="noopener" target="_blank" pill size="sm" variant="primary" @click="leaveFor" href="https://g.126.fm/03v0UW4" >前往平台游玩</b-button>
			</b-navbar-nav>
		</div>
    </b-navbar>

	<div class="card-container" >
		<div class="card-content" >
			<div class="description-container" style="text-align: center;" >
				<div>
					<h1>恐慌降临</h1>
					<h3>夜幕降临死者归来</h3>
					<p>瘟疫在洛丹伦王国迅速蔓延开来，无数的民众死亡然后重新归来。一些民众不得已放弃城市并逃入森林，试图靠森林的复杂地势来抵御死者的进攻，然而，除了死者的威胁，森林中还暗藏危机。
					</p>
					<PartnerAuthor></PartnerAuthor>
				</div>
			</div>
			<div class="img-container" >
				<img src="@/assets/War_Map/Panic_Befall/blue_and_red_base.png" >
			</div>
		</div>
	</div>

    
    <div class="card-container" >
      <div class="card-content" >
        <b-row no-gutters>
          <b-col sm="6">
            
            <div class="img-container" >
              <img src="@/assets/War_Map/Panic_Befall/blue_under_attack_2.png" >
            </div>
                
          </b-col>
          <b-col sm="6">
            
            <div class="description-container">
              <div>
				<h2>夜幕降临死者归来</h2>
				<h3>死亡的单位会变成僵尸，单位死亡传播瘟疫</h3>
				<p>稳步推进还是闪电攻势，这是个问题。每一次进攻都将面临这样的考验，过度损失单位会被自己反噬，这是何等的绝望。
                </p>
              </div>
            </div>
            
          </b-col>
        </b-row>
      </div>
    </div>

  </div>
</template>

<style lang="stylus" scoped>
	@import '~@/components/OverviewCard.styl'
</style>

<script>
import PartnerAuthor from '@/components/PartnerAuthor'
export default {
    methods: {
        leaveFor() {
            this.$ga.event('war-map', 'dzclient', 'panic-befall', 1)
            },
	},
  name: 'about',
    components: {
        PartnerAuthor
  }
}
</script>